import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Industries from './components/Industries';
import Solutions from './components/Solutions';
import GlobalPresence from './components/GlobalPresence';
import Innovation from './components/Innovation';
import Insights from './components/Insights';
import Careers from './components/Careers';
import Footer from './components/Footer';

// Pages
import About from './pages/About';
import AIServices from './pages/AIServices';
import CloudServices from './pages/CloudServices';
import DigitalTransformation from './pages/DigitalTransformation';
import BankingServices from './pages/BankingServices';
import Contact from './pages/Contact';
import CareersPage from './pages/CareersPage';
import JobDetails from './pages/JobDetails';
import CybersecurityServices from './pages/CybersecurityServices';
import DataAnalytics from './pages/DataAnalytics';
import HealthcareServices from './pages/HealthcareServices';
import ApplicationDevelopment from './pages/ApplicationDevelopment';
import InsightsPage from './pages/InsightsPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import ManufacturingServices from './pages/ManufacturingServices';
import RetailServices from './pages/RetailServices';
import EnergyServices from './pages/EnergyServices';
import GovernmentServices from './pages/GovernmentServices';
import InsightDetail from './pages/InsightDetail';
import './styles/App.css';
import './styles/enhanced.css';

function App() {
  return (
    <div className="App">
      <Header />
      <Routes>
          <Route path="/" element={
            <>
              <Hero />
              <Services />
              <Industries />
              <Solutions />
              <GlobalPresence />
              <Innovation />
              <Insights />
              <Careers />
            </>
          } />
          
          {/* Service Pages */}
          <Route path="/services" element={<Services />} />
          <Route path="/ai-machine-learning" element={<AIServices />} />
          <Route path="/cloud-services" element={<CloudServices />} />
          <Route path="/digital-transformation" element={<DigitalTransformation />} />
          <Route path="/cybersecurity" element={<CybersecurityServices />} />
          <Route path="/data-analytics" element={<DataAnalytics />} />
          <Route path="/application-development" element={<ApplicationDevelopment />} />
          
          {/* Industry Pages */}
          <Route path="/industries" element={<Industries />} />
          <Route path="/banking-financial-services" element={<BankingServices />} />
          <Route path="/healthcare-life-sciences" element={<HealthcareServices />} />
          <Route path="/manufacturing" element={<ManufacturingServices />} />
          <Route path="/retail" element={<RetailServices />} />
          <Route path="/energy" element={<EnergyServices />} />
          <Route path="/government" element={<GovernmentServices />} />
          
          {/* Company Pages */}
          <Route path="/about" element={<About />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/careers/job/:id" element={<JobDetails />} />
          <Route path="/insights" element={<InsightsPage />} />
          <Route path="/insights/:id" element={<InsightDetail />} />
          <Route path="/contact" element={<Contact />} />
          
          {/* Legal Pages */}
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/cookies" element={<PrivacyPolicy />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;